import React from "react";

const ConnectionQualityIndicator = ({
  quality,
  width = 29,
  height = 24,
}: {
  quality: any;
  width: any;
  height: any;
}) => {
  // Define colors for each quality level
  const getColor = (quality: any) => {
    switch (quality) {
      case 1:
        return "red"; // Poor connection
      case 2:
        return "yellow"; // Average connection
      case 3:
        return "green"; // Excellent connection
      default:
        return "#E0E0E0"; // Default inactive color
    }
  };

  const activeColor = getColor(quality);

  // Render the SVG with dynamic bar fill colors
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.31818 24C0.527273 24 0 23.4 0 22.5V16.5C0 15.6 0.527273 15 1.31818 15C2.10909 15 2.63636 15.6 2.63636 16.5V22.5C2.63636 23.4 2.10909 24 1.31818 24Z"
        fill={quality >= 1 ? activeColor : "#E0E0E0"}
      />
      <path
        d="M6.59091 24C5.8 24 5.27273 23.4 5.27273 22.5V13.5C5.27273 12.6 5.8 12 6.59091 12C7.38182 12 7.90909 12.6 7.90909 13.5V22.5C7.90909 23.4 7.38182 24 6.59091 24Z"
        fill={quality >= 1 ? activeColor : "#E0E0E0"}
      />
      <path
        d="M11.8636 24C11.0727 24 10.5455 23.4 10.5455 22.5V10.5C10.5455 9.6 11.0727 9 11.8636 9C12.6545 9 13.1818 9.6 13.1818 10.5V22.5C13.1818 23.4 12.6545 24 11.8636 24Z"
        fill={quality >= 2 ? activeColor : "#E0E0E0"}
      />
      <path
        d="M17.1364 24C16.3455 24 15.8182 23.4 15.8182 22.5V7.5C15.8182 6.6 16.3455 6 17.1364 6C17.9273 6 18.4545 6.6 18.4545 7.5V22.5C18.4545 23.4 17.9273 24 17.1364 24Z"
        fill={quality >= 2 ? activeColor : "#E0E0E0"}
      />
      <path
        d="M22.4091 24C21.6182 24 21.0909 23.4 21.0909 22.5V4.5C21.0909 3.6 21.6182 3 22.4091 3C23.2 3 23.7273 3.6 23.7273 4.5V22.5C23.7273 23.4 23.2 24 22.4091 24Z"
        fill={quality >= 3 ? activeColor : "#E0E0E0"}
      />
      <path
        d="M27.6818 24C26.8909 24 26.3636 23.4 26.3636 22.5V1.5C26.3636 0.6 26.8909 0 27.6818 0C28.4727 0 29 0.6 29 1.5V22.5C29 23.4 28.4727 24 27.6818 24Z"
        fill={quality >= 3 ? activeColor : "#E0E0E0"}
      />
    </svg>
  );
};

export default ConnectionQualityIndicator;
